export default __webpack_public_path__ + "static/offcentre-68821a38028e7a869ece4c165ff81413.png";